import React, { useState, useEffect } from "react";
import { Button, Spinner } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";

/**
 * Foto de un articulo o de una habilitacion, con boton para subirla o
 * reemplazarla ahi mismo. Es la que sale en la Orden de Produccion.
 * Viven en Cloudinary con el _id como nombre (FileController /upprofile).
 */
const CARPETAS = { articulos: "cavannaMezclillaArticulos", habilitacion: "cavannaMezclillaHabilitacion" };

const encabezados = () => ({
  headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
});

function FotoRegistro({ id, carpeta = "articulos", tamano = 90, compacto = false }) {
  const [version, setVersion] = useState("");
  const [subiendo, setSubiendo] = useState(false);
  const inputId = `foto-${carpeta}-${id}`;

  useEffect(() => {
    setVersion("");
    if (!id) return;
    let vigente = true;
    const q = carpeta === "habilitacion" ? "?carpeta=habilitacion" : "";
    axios
      .get(`${process.env.REACT_APP_URL_GETMEDIA}/${id}${q}`, encabezados())
      .then((r) => vigente && r.data && r.data.version && setVersion(r.data.version))
      .catch(() => {});
    return () => {
      vigente = false;
    };
  }, [id, carpeta]);

  function subir(archivo) {
    if (!archivo) return;
    if (!archivo.type.startsWith("image/")) {
      Swal.fire("Archivo no válido", "Elige una imagen (JPG o PNG)", "warning");
      return;
    }
    setSubiendo(true);
    const formData = new FormData();
    formData.append(carpeta === "habilitacion" ? "habilitacion" : "articulo", id);
    formData.append("file", archivo);
    axios
      .post(process.env.REACT_APP_URL_UPPROFILE, formData, encabezados())
      .then((r) => setVersion(r.data.version))
      .catch((error) =>
        Swal.fire(
          "No se pudo subir la foto",
          (error.response && error.response.data && error.response.data.message) || "Intenta de nuevo",
          "error"
        )
      )
      .finally(() => setSubiendo(false));
  }

  if (!id) return null;
  const src = version
    ? `${process.env.REACT_APP_URL_FOTO_CLOUDINARY}/image/upload/c_limit,w_300,h_300/v${version}/${CARPETAS[carpeta]}/${id}`
    : "";
  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
      {src ? (
        <a href={src.replace("c_limit,w_300,h_300/", "")} target="_blank" rel="noopener noreferrer">
          <img src={src} alt="foto" style={{ maxWidth: tamano, maxHeight: tamano, borderRadius: 4, border: "1px solid #ddd" }} />
        </a>
      ) : compacto ? null : (
        <span className="text-muted" style={{ fontSize: 12 }}>
          Sin foto
        </span>
      )}
      <input
        id={inputId}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={(e) => {
          subir(e.target.files && e.target.files[0]);
          e.target.value = "";
        }}
      />
      <Button
        size="sm"
        color={src ? "light" : "info"}
        disabled={subiendo}
        title={src ? "Cambiar foto" : "Subir foto"}
        onClick={() => document.getElementById(inputId).click()}
      >
        {subiendo ? <Spinner size="sm" /> : <i className="fas fa-camera" />}
        {compacto ? "" : src ? " Cambiar" : " Subir foto"}
      </Button>
    </div>
  );
}

export default FotoRegistro;

/**
 * Foto junto a una partida (OC): la de la habilitacion elegida, la misma que
 * sale en la explosion y en la Orden de Produccion. Sin habilitacion elegida
 * el boton queda apagado.
 */
export function FotoPartida({ id }) {
  return (
    <span style={{ display: "inline-block", marginLeft: 6, verticalAlign: "middle" }}>
      {id ? (
        <FotoRegistro id={id} carpeta="habilitacion" tamano={34} compacto />
      ) : (
        <Button size="sm" color="info" disabled title="Elige la habilitación para agregarle foto">
          <i className="fas fa-camera" />
        </Button>
      )}
    </span>
  );
}
